// extracted by mini-css-extract-plugin
export default {"root":"AxisCell_root__n-HGm","selected":"AxisCell_selected__mcPMc","handle":"AxisCell_handle__UnPZ6"};